import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
} from "@reduxjs/toolkit/dist/query/react"
import Cookies from "js-cookie"

const baseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_APP_API_URL}/api/v1`,
  credentials: "include",
  prepareHeaders: (headers) => {
    const userToken = Cookies.get()["User"]

    headers.set("Authorization", `Bearer ${userToken}`)
  },
})

export const authQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const result = await baseQuery(args, api, extraOptions)
  if (result.error && result.error.status === 401) {
    // try to get a new token
    authRedirectTargetUrl()
  }
  return result
}

export const authRedirectTargetUrl = () => {
  const m = import.meta.env.VITE_AUTH_LOGIN_URL
  const targeted = buildTargetParams(window.location.href)
  window.location.assign(m + targeted)
}

export const buildTargetParams = (target: string): string => {
  const passOn = import.meta.env.VITE_PASS_ON_TOKEN ? "pass_on_url=1&" : ""
  return `?${passOn}target=${encodeURIComponent(target)}`
}

export const checkSetPassOnParams = (): boolean => {
  if (!import.meta.env.VITE_PASS_ON_TOKEN) return false
  const params = new URLSearchParams(location.search)
  if (!params.get("token")) return false
  document.cookie = `User=${params.get("token")}`

  // cleanup token from url
  params.delete("token")
  const search = params.toString() ? `?${params.toString()}` : ""
  window.location.assign(`${window.location.pathname}${search}`)

  return true
}
